import { useContext } from 'react';
import { AccountContext } from '../contexts/AccountContext';

export const useAccount = () => useContext(AccountContext);

